module.exports = __webpack_public_path__ + "img/2V.2.59ccc1e2.jpg";